<template>
  <div class="theme" v-tooltip.right="themeName">
    <component
      :is="light ? 'light-icon' : 'dark-icon'"
      class="theme__icon"
      @click="toggleTheme"
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import LightIcon from '@/assets/icons/light.svg';
import DarkIcon from '@/assets/icons/dark.svg';

export default {
  components: {
    LightIcon,
    DarkIcon,
  },
  props: {
    theme: {
      type: String,
      required: true,
    },
  },
  computed: {
    light() {
      return this.theme === 'light';
    },
    themeName() {
      return this.light ? this.$t('theme.light') : this.$t('theme.dark');
    },
  },
  methods: {
    ...mapMutations([
      'toggleAppTheme',
    ]),
    toggleTheme() {
      this.toggleAppTheme(this.light ? 'dark' : 'light');
    },
  },

};
</script>

<style scoped lang="scss">
@import "~styles/components/theme-button.scss";
</style>
